import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { createRemainsOrder, updateRemainsOrder } from "../../api/thunks";
import { CartSliceState, NewOrderResponseType } from "../types";

export const addCheckoutExtraReducers = (
  builder: ActionReducerMapBuilder<CartSliceState>,
) => {
  builder.addCase(createRemainsOrder.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });

  builder.addCase(
    createRemainsOrder.fulfilled,
    (state, action: PayloadAction<NewOrderResponseType>) => {
      state.newRemainsOrder = action.payload.orders;
      state.error = null;
      state.isLoading = false;
    },
  );
  builder.addCase(createRemainsOrder.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(updateRemainsOrder.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });

  builder.addCase(
    updateRemainsOrder.fulfilled,
    (state, action: PayloadAction<NewOrderResponseType["orders"]>) => {
      state.newRemainsOrder = action.payload;
      state.error = null;
      state.isLoading = false;
    },
  );
  builder.addCase(updateRemainsOrder.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });
};
